import { useTranslation } from "react-i18next";
import { User, Storefront, Truck, ShieldCheck, Crown, ArrowRight } from "@phosphor-icons/react";

/**
 * Entry portal — user picks their role-specific login.
 * Each card calls onPickRole(roleId) which then takes them to <AuthPage role={roleId} />.
 */
export default function RolePortal({ onPickRole, onSkipDemo }) {
  const { t } = useTranslation();

  const roles = [
    { id: "user",          icon: User,        color: "#2D4A3E", title: t("portal.user_title"),         desc: t("portal.user_desc") },
    { id: "intermediary",  icon: Storefront,  color: "#0ea5e9", title: t("portal.intermediary_title"), desc: t("portal.intermediary_desc") },
    { id: "driver",        icon: Truck,       color: "#f59e0b", title: t("portal.driver_title"),       desc: t("portal.driver_desc") },
    { id: "admin",         icon: ShieldCheck, color: "#8b5cf6", title: t("portal.admin_title"),        desc: t("portal.admin_desc") },
    { id: "super_admin",   icon: Crown,       color: "#dc2626", title: t("portal.super_admin_title"),  desc: t("portal.super_admin_desc") },
  ];

  return (
    <div data-testid="role-portal" style={{ minHeight: "100vh", background: "var(--bg)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div style={{ maxWidth: 940, width: "100%" }}>
        <div className="flex items-center gap-3 justify-center mb-6">
          <img src="/assets/logo.png" alt="Bluemove" style={{ height: 48 }} />
        </div>
        <h1 style={{ fontFamily: "Outfit", fontWeight: 800, fontSize: "1.9rem", textAlign: "center", marginBottom: 6 }}>
          {t("portal.title")}
        </h1>
        <p style={{ color: "var(--text-muted)", textAlign: "center", marginBottom: 28, fontSize: "0.95rem" }}>
          {t("portal.subtitle")}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="role-portal-grid">
          {roles.map(r => {
            const Icon = r.icon;
            return (
              <button
                key={r.id}
                data-testid={`portal-${r.id}`}
                onClick={() => onPickRole(r.id)}
                className="card-hover text-left"
                style={{
                  position: "relative",
                  padding: 20,
                  borderRadius: 16,
                  border: `1px solid var(--border-color)`,
                  background: "var(--surface)",
                  cursor: "pointer",
                  transition: "all .25s",
                  borderTop: `3px solid ${r.color}`,
                }}
              >
                <div style={{ width: 48, height: 48, borderRadius: 14, background: `${r.color}1a`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 12 }}>
                  <Icon size={26} weight="duotone" style={{ color: r.color }} />
                </div>
                <div style={{ fontFamily: "Outfit", fontWeight: 700, fontSize: "1.05rem", marginBottom: 4 }}>{r.title}</div>
                <p style={{ color: "var(--text-muted)", fontSize: "0.78rem", lineHeight: 1.4 }}>{r.desc}</p>
                <div className="flex items-center gap-1 mt-3" style={{ color: r.color, fontWeight: 600, fontSize: "0.78rem" }}>
                  {t("portal.go")} <ArrowRight size={14} weight="bold" />
                </div>
              </button>
            );
          })}
        </div>

        <div className="text-center mt-8">
          <button
            data-testid="skip-to-demo-btn"
            onClick={onSkipDemo}
            style={{ background: "none", border: "none", color: "var(--text-muted)", cursor: "pointer", fontSize: "0.85rem", textDecoration: "underline" }}
          >
            {t("auth.demo_link")}
          </button>
        </div>
      </div>
    </div>
  );
}
